import * as S from "./style";
import { useEffect, useState } from "react";
import axiosInstance from "services/axiosInstance";
import { Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";
//Componentes
import CreditCard from "../CreditCard";
//Utils
import { HandleSelectedPayment } from "utils/FunctionPayment";
import CombinedPayment from "../CombinedPayment";
import { IMethPay } from "Interfaces/IMethodPaym";

interface ICreat {
  register: any;
  errors: any;
  reset: any;
  resetField: any;
  control: any;
  getValues: any;
  watch: any;
  setValue: any;
  minimum_value: string,
}

export default function CreditStorePayment({
  register,
  errors,
  reset,
  resetField,
  control,
  getValues,
  watch,
  setValue,
  minimum_value
}: ICreat) {
  const [formPay, setFormPay] = useState<IMethPay[]>([]);
  const [formPaymentSelec, setFormPaymentSelec] = useState("");

  const ModalSelectedPayment = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const result = HandleSelectedPayment(event);
    const name_payment = event.target.options[event.target.selectedIndex].text;
    setValue(`payments.down_payments[0].name_payment`, name_payment);

    if (typeof result === "object") {
      const name = result.name;

      setFormPaymentSelec(name);
    } else {
      console.log("Nenhum pagamento selecionado.");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("payment-method");

        const paymentData = response.data.filter((val: IMethPay) => (
          val.payment_method !== 'Crediário da Loja'
        ));

        setFormPay(paymentData);
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    fetchData();
  }, []);

  // efeito separado só para mínimo
  useEffect(() => {
    if (minimum_value) {
      setValue("payments.down_payment", minimum_value);
    }
  }, [minimum_value, setValue]);

  return (
    <S.Container>
      <S.Content>
        <S.FormInput>
          <S.Label htmlFor="payments.to_receive">
            A Receber
          </S.Label>
          <Controller
            name="payments.to_receive"
            control={control}
            render={({ field: { onChange, value, ref } }) => (
              <NumericFormat
                className="InputDiscout"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale={true}
                placeholder="R$ 0,00"
                prefix="R$ "
                value={value}
                onValueChange={(values) => {
                  const purchaseValue = values.floatValue ?? 0;
                  onChange(purchaseValue);
                }}
                getInputRef={ref}
              />
            )}
          />
        </S.FormInput>

        <S.SeparateDiv>
          <S.FormInput>
            <S.Label htmlFor="payment_method_id">
              Forma de Entrada
            </S.Label>
            <S.Select
              id="payments.down_payments.payment_method_id"
              {...register("payments.down_payments[0].payment_method_id")}
              onChange={(e) => ModalSelectedPayment(e)}
            >
              <option value="" disabled selected hidden>
                Selecione
              </option>
              {formPay.map((val) => {
                const value = val.id;

                return (
                  <option key={value} value={value}>
                    {val.payment_method}
                  </option>
                );
              })}
              <option value={'pag. combinado'}>
                Pag. Combinado
              </option>
            </S.Select>
          </S.FormInput>

          <S.FormInput>
            <S.Label htmlFor="payments.down_payment">
              Valor da Entrada
            </S.Label>
            <Controller
              name="payments.down_payment"
              control={control}
              defaultValue={minimum_value || 0} // ✅ seta valor inicial aqui
              render={({ field: { onChange, value, ref } }) => (
                <NumericFormat
                  className="InputDiscout"
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale={true}
                  placeholder="R$ 0,00"
                  prefix="R$ "
                  value={value} // ✅ agora o RHF controla
                  onValueChange={(values) => {
                    const purchaseValue = values.floatValue ?? 0;
                    onChange(purchaseValue);
                  }}
                  getInputRef={ref}
                />
              )}
            />
          </S.FormInput>
        </S.SeparateDiv>

        {formPaymentSelec === "credit-card" && (
          <CreditCard
            register={register}
            errors={errors}
            reset={reset}
            resetField={resetField}
            subtotal={watch("payments.down_payment") || 0}
            index={0}
            responsaData={(id, interestRate, parcela) => {
              setValue("payments.down_payments[0].installment_on_credit_card_id", id);
              setValue("payments.down_payments[0].installment_interest_rate", interestRate);
              setValue("payments.down_payments[0].number_installment", parcela);
            }}
          />
        )}

        {formPaymentSelec === "combined-payment" && (
          <CombinedPayment
            watch={watch}
            getValues={getValues}
            register={register}
            errors={errors}
            reset={reset}
            resetField={resetField}
            control={control}
            setValue={setValue}
            isCredit={false}
          />
        )}

        <S.SeparateDiv>
          <S.FormInput>
            <S.Label htmlFor="payments.first_due_date">
              Data de Vencimento <span>*</span>
            </S.Label>
            <S.Input
              type="date"
              {...register('payments.first_due_date', { require: true })}
            />
            {errors.first_due_date && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>

          <S.FormInput>
            <S.Label htmlFor='payments.payment_credit_installment'>
              Quantidade de Parcelas <span>*</span>
            </S.Label>
            <S.Input
              placeholder="0"
              type="number"
              {...register('payments.payment_credit_installment', { required: true })}
            />
            {errors.payment_credit_installment && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>
        </S.SeparateDiv>
      </S.Content>
    </S.Container >
  );
}
